import { CircularProgress, InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { Search } from 'lucide-react';


const CustomSearch = ({
    searchQuery,
    onSearchChange,
    isLoading = false,
    placeholder,
    sx
}) => {
    return (
        <TextField
            fullWidth
            placeholder={placeholder}
            variant="outlined"
            size="small"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            sx={{
                // mb: 3,
                ...sx,
                "& .MuiOutlinedInput-root": {
                    backgroundColor: "#fff",
                    height: 40,
                    borderRadius: "10px",
                    alignItems: "center",
                    paddingLeft: "12px",
                },
                "& .MuiOutlinedInput-input": {
                    padding: "0 15px 2px 4px",
                    height: "100%",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #CBCBCB",
                    borderRadius: "10px",
                },
                "&:hover .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #CBCBCB",
                },
                "& .MuiOutlinedInput-input::placeholder": {
                    color: "#A1A1A1",
                    opacity: 1,
                },
            }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start" sx={{ mr: 0, display: "flex", alignItems: "center" }}>
                        <Search size={18} className='lucid-icons-class' color="#A1A1A1" style={{ marginRight: '6px' }} />
                    </InputAdornment>
                ),
                endAdornment: isLoading && searchQuery && (
                    <InputAdornment position="end">
                        <CircularProgress size={20} />
                    </InputAdornment>
                ),
            }}
            type='search'
        />
    )
}

export default CustomSearch;